import React, { useEffect, useState } from 'react'




import ProjectTransaction from '../components/ProjectTransactionList';
import ProjectLayout from '../../../../../layout/components/ProjectLayout';
import { useParams } from 'react-router-dom';
import transactionReportServices from '../../transaction/transactionReportServices';
import VendorTransactionAnalytics from '../../transaction/components/VendorTransactionAnalytics';
import PayeeTypeAnalytics from '../../transaction/components/PayeeTypeAnalytics';
import CategoryTransactionAnalytics from '../../transaction/components/CategoryTransactionAnalytics';

function ProjectTransactionPage() {
    
    const {id} = useParams();
    const [projectTransactionList,setProjectTransactionList] = useState(null);
    const getProjectTransactionList =() =>{
        transactionReportServices.getItemListByProject(id).then(res=>{
            setProjectTransactionList(res.data);
        }).catch(error=>{

        })
    }

    return (
        <ProjectLayout>
            <ProjectTransaction transactionItemList={projectTransactionList} getTransactionItemList={getProjectTransactionList} />
            <div className='row'>
              <div className='col-md-6'>
                <VendorTransactionAnalytics transactionItemList={projectTransactionList} />
              </div>
              <div className='col-md-6'>
                <PayeeTypeAnalytics transactionItemList={projectTransactionList} />
              </div>
              <div className='col-md-6'>
                <CategoryTransactionAnalytics transactionItemList={projectTransactionList} />
              </div>
            </div>
        </ProjectLayout>
    )
}

export default ProjectTransactionPage

